import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcArrowrightFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 6.55c0-.46.539-.716.903-.429l6.888 5.45a.546.546 0 0 1 0 .858l-6.888 5.45c-.364.287-.903.031-.903-.43z"
  }));
}
var IcArrowrightFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcArrowrightFill));

export { IcArrowrightFill as I };
